import { render, staticRenderFns } from "./editSpace.vue?vue&type=template&id=3f055592"
import script from "./editSpace.vue?vue&type=script&lang=js"
export * from "./editSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports